module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/location_type_both_location-f8e91413d2ebab1383be4ca3711fae05.webp";